import { areTimeDisplaysIdenticalAcrossTimezones } from "./areTimeDisplaysIdenticalAcrossTimezones";
import { formatTime } from "./formatTime";
import { formatTimeWithTimezone } from "./formatTimeWithTimezone";
import { formatTimezoneWithOffset } from "./formatTimezoneWithOffset";
import { getTimezoneDifferenceInHours } from "./getTimezoneDifferenceInHours";

interface TimeDisplayOptions {
  time: Date;
  displayInTimezone: string;
  compareToTimezone?: string;
  useTimezoneOffset?: boolean;
}

/**
 * Formats a time, conditionally including the timezone when it differs from the comparison timezone.
 * When useTimezoneOffset is true, includes the timezone offset information in the display.
 */
export function formatTimeWithTimezoneDisambiguation(options: TimeDisplayOptions): string {
  const { time, displayInTimezone, compareToTimezone, useTimezoneOffset = false } = options;

  const timeString = formatTime(time, displayInTimezone);

  if (!compareToTimezone) {
    return timeString;
  }

  if (areTimeDisplaysIdenticalAcrossTimezones(time, displayInTimezone, compareToTimezone)) {
    return timeString;
  }

  if (useTimezoneOffset) {
    const timezoneDifferenceInHours = getTimezoneDifferenceInHours(
      displayInTimezone,
      compareToTimezone
    );
    return `${timeString} ${formatTimezoneWithOffset(
      displayInTimezone,
      timezoneDifferenceInHours
    )}`;
  }

  return formatTimeWithTimezone(time, displayInTimezone, true);
}
